import { render, staticRenderFns } from "./indexConcurrentEvents.vue?vue&type=template&id=68911b6c&scoped=true&"
import script from "./indexConcurrentEvents.vue?vue&type=script&lang=js&"
export * from "./indexConcurrentEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68911b6c",
  null
  
)

export default component.exports